export default "__VITE_ASSET__BTs9ZrQn__"